import React, { useEffect, useState } from 'react'
import { getDecoration, getMiscellinious, getPhotography } from '../../Services/Operations/ProductAPI';
import "./Miscelinous.css"
import DOMPurify from "dompurify";

const Misscelinous = () => {
    const[filtered,setfiltered]=useState([])
    const[filtered1,setfiltered1]=useState([])
    const[filtered2,setfiltered2]=useState([])
    const getmiscellinous=async()=>{
        try {
            const res= await getMiscellinious()
            console.log('getMiscellinious',res);
            setfiltered(res.data.data)
            
        } catch (error) {
           console.log(error);
            
        }
    }

     const getphotography=async()=>{
        try {
            const res= await getPhotography()
            console.log('getPhotography',res);
            setfiltered2(res.data.data)
            
        } catch (error) {
           console.log(error);
            
        }
    }
     const getdecoration=async()=>{
        try {
            const res= await getDecoration()
            console.log('getDecoration',res);
            setfiltered1(res.data.data)
            
        } catch (error) {
           console.log(error);
            
        }
    }

    useEffect(() => {
      getmiscellinous()
      getdecoration()
      getphotography()
    }, [])
    
  const [activeTab, setActiveTab] = useState("Wedding");

  // Dummy data (same structure as your API)
  const data = [
    {
      id: 1,
      event_name: "Wedding",
      event_type: "Silver",
      price: 50000,
      location: "Kolkata",
      plot_size: 1200,
    },
    {
      id: 2,
      event_name: "Wedding",
      event_type: "Gold",
      price: 90000,
      location: "Kolkata",
      plot_size: 2000,
    },
    {
      id: 3,
      event_name: "Birth Day",
      event_type: "Basic",
      price: 20000,
      location: "Kalyani",
      plot_size: 800,
    },
  ];



  return (
    <>
     <section className="demo-section">
      <div className="container">

        <h2 className="main-title">
         Banquet <span>Decoration</span>
           
        </h2>

        {/* Tabs */}
        

        {/* Cards */}
        <div className="cards">
          {filtered1.length === 0 && (
            <p className="no-data">No packages available</p>
          )}

               <div className="deco-cards">
          {filtered1.map((item) => (
            <div
              key={item.id}
              className={`deco-card ${
                item.deco_type === "Premium" ? "premium" : ""
              }`}
            >
              {/* Badge */}
              {item.deco_type === "Premium" && (
                <div className="badge">Top Choice</div>
              )}

              {/* Title */}
              <h3>{item.deco_name}</h3>
              <p className="type">{item.deco_type}</p>

              {/* Price */}
              <h2 className="price">
                ₹{Number(item.price).toLocaleString()}
                <span> + GST</span>
              </h2>

              {/* Features (HTML from API) */}
              <div
                className="feature-list"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(item.deco_feature),
                }}
              />

              {/* Button */}
              <button className="btn">Enquire Now</button>
            </div>
          ))}
        </div>
        </div>
      </div>
    </section>
      <section className="demo-section">
      <div className="container">

        <h2 className="main-title">
         Banquet <span>Photography</span>
           
        </h2>

        {/* Tabs */}
        

        {/* Cards */}
        <div className="cards">
          {filtered2.length === 0 && (
            <p className="no-data">No packages available</p>
          )}

             <div className="photo-cards">
          {filtered2.map((item) => {
            const safeHTML = DOMPurify.sanitize(item.photo_feature);

            return (
              <div
                key={item.id}
                className={`photo-card ${
                  item.photo_type === "Premium" ? "premium" : ""
                }`}
              >
                {/* Badge */}
                {item.photo_type === "Premium" && (
                  <div className="badge">Best Seller</div>
                )}

                {/* Name */}
                <h3>{item.photo_name}</h3>
                <p className="type">{item.photo_type}</p>

                {/* Price */}
                <h2 className="price">
                  ₹{Number(item.price).toLocaleString()}
                  <span> + GST</span>
                </h2>

                {/* Features */}
                <div
                  className="feature-list"
                  dangerouslySetInnerHTML={{ __html: safeHTML }}
                />

                {/* Button */}
                <button className="btn">Book Now</button>
              </div>
            );
          })}
        </div>
        </div>
      </div>
    </section>
    <section className="demo-section">
      <div className="container">

        <h2 className="main-title">
         Banquet <span>miscellaneous</span>
           
        </h2>

        {/* Tabs */}
        

        {/* Cards */}
        <div className="cards">
          {filtered.length === 0 && (
            <p className="no-data">No packages available</p>
          )}

          {filtered.map((item) => (
            <div
              key={item.id}
              className={`card ${
                item.event_type === "Gold" ? "premium" : ""
              }`}
            >
              {item.event_type === "Gold" && (
                <div className="badge">Most Popular</div>
              )}

              <h3>{item.event_type}</h3>

              <h2 className="price">
                ₹{item.price} <span>+ GST</span>
              </h2>

              <ul>
                <li>✔ Location: {item.location}</li>
                <li>✔ Plot Size: {item.plot_size} sq.ft</li>
              </ul>

              <button className="btn">View Details</button>
            </div>
          ))}
        </div>
      </div>
    </section>
    </>
  );
}

export default Misscelinous

